import React, { useState } from 'react';
import './certificateOverview.css';
import { Download, DownloadIcon } from '../../constants';
import { downloadFile, downloadYearWiseReport } from '../../helper-functions';

interface Props {
  totalRequests: number;
  activeCertificates: number;
  pendingRequests: number;
  expiredCertificates: number;
  cancelledCertificates: number;
  userId:any;
}

const CertificateOverview: React.FC<Props> = ({
  totalRequests,
  activeCertificates,
  pendingRequests,
  expiredCertificates,
  cancelledCertificates,
  userId
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const years = Array.from({ length: currentYear - 2025 + 1 }, (_, i) => 2025 + i);

  const handleDownloadReport = async () => {
      setIsDownloading(true);
      try {
        await downloadYearWiseReport(selectedYear);
      } finally {
        setIsDownloading(false);
      }
    };

  return (
    <div className="certificate-overview">
      <div className='cert-cont'>
      <h3 className='heading' style={{marginTop:0}}>Certificate Overview</h3>
      <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
        {isDownloading ? (
          <div className="download-spinner">Downloading...</div>
        ) : (
          <div onClick={handleDownloadReport} style={{cursor:'pointer', display:'flex', flexDirection:'row', alignItems:'center'}}>
            <img src={DownloadIcon} style={{height:20}}/>
            <span className='downloadfull'>Download Full Report</span>
          </div>
        )}
     
      <div className="year-selector">
            <select value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
              {years.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
      </div>
      </div>
      <div className="overview-cards">
        <div className="overview-card">
          <p>Issued Certificates</p>
          <h3>{totalRequests}</h3>
        </div>
        <div className="overview-card">
          <p>Active Certificates</p>
          <h3>{activeCertificates}</h3>
        </div>

       
        <div className="overview-card">
          <p>Expired Certificates</p>
          <h3>{expiredCertificates}</h3>
        </div>
        <div className="overview-card">
          <p>Cancelled Certificates</p>
          <h3>{cancelledCertificates}</h3>
        </div>
      </div>
    </div>
  );
};

export default CertificateOverview;
